import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import UseServices from "Hooks/UseServices";

import * as S from "./styles";

// Sessão CONTRAPARTIDAS do projeto, na área do usuário.
//
// SOMENTE LEITURA para todo mundo desde 03/09/2026 (D10 da parte 2): o
// patrocinador já era, e o PROPONENTE perdeu criar, editar e **anexar** —
// consequência C3, aceita pelo cliente (o comprovante passa a chegar por fora e
// alguém da Equipe Sevenx sobe à mão). A escrita vive só em
// /admin/projects/update/:id → aba "Contrapartidas".
//
// Por isso o componente não busca mais patrocinadores nem cotas: as duas listas
// só existiam para alimentar os selects do formulário, que saiu daqui. O nome do
// patrocinador vem no próprio payload (include de `getCounterpartsByProjectId`).
const Counterparts = ({ projectId }) => {
  const { api } = UseServices();

  const [counterparts, setCounterparts] = useState([]);

  useEffect(() => {
    return getProjectCounterparts(projectId);

    // eslint-disable-next-line
  }, []);

  const getProjectCounterparts = (project_id) => {
    api
      .post("/counterparts/get-counterparts-by-project-id", {
        project_id: project_id,
      })
      .then((response) => setCounterparts(response.data?.counterparts || []))
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return (
    <S.Wrapper>
      <Form>
        <S.Section>
          <span>Contrapartidas</span>
          <hr />
        </S.Section>

        {!counterparts.length ? (
          <span>Nenhuma contrapartida cadastrada.</span>
        ) : null}

        {counterparts.map((counterpart) => (
          <S.Counterpart key={counterpart.id}>
            <S.CounterpartInfos>
              {/* Sem o campo Nome (D10), a contrapartida se identifica pela
                  DESCRIÇÃO. */}
              <S.Header>
                <h2>{counterpart.description}</h2>
                <p>{counterpart.status}</p>
              </S.Header>
              <span>
                <strong>Patrocinador:</strong>{" "}
                {counterpart.project_sponsor?.sponsor?.full_name ||
                  "Não Cadastrado"}
              </span>

              {counterpart.files?.length ? (
                <S.Files>
                  <strong>Arquivos:</strong>
                  {counterpart.files.map((file) => (
                    <a
                      key={file.id}
                      href={file.file_src}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {file.name}
                    </a>
                  ))}
                </S.Files>
              ) : null}
            </S.CounterpartInfos>
          </S.Counterpart>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default Counterparts;
